module.exports = __webpack_public_path__ + "img/support.4a2faa5a.png";